import React from "react";
import styles from "../chatPage.scss";
import { Card } from "antd";
import { Link, useLocation } from "react-router-dom";
import { getIconUrl } from "../../../services/asset";
import { PageRoute } from "../../../models";
import { Chat, UserI } from "../../../typings/interfaces";
import { DropdownMenu } from "./DropdownMenu";
import RatingButton from "../../../components/RatingButton";
import RatingCounter from "../../../components/RatingCounter";
import { IndexAvatar } from "../../../components";
import { getWindowWidth, isMobileScreen } from "../../../services/utils";
import { ChevronLeftIcon } from "../../HomePage/ChevronLeftIcon";

type Props = {
  chatId?: string;
  user: UserI;
  otherChatParticipantInfo: {
    userId?: string;
    name?: string;
    avatar?: string;
    lastReadMessageId?: string;
  };
  chat?: Chat;
  isOtherUserBlocked: boolean;
}

export const HeaderCard = ({ chatId, user, otherChatParticipantInfo, chat, isOtherUserBlocked }: Props) => {
  const location = useLocation();
  const isMobile = isMobileScreen(getWindowWidth());

  const backUrl = (() => {
    const params = new URLSearchParams(location.search);
    params.delete("chatId");
    params.delete("adId");
    const search = params.toString();
    return {
      pathname: PageRoute.chats,
      search: search || undefined,
      state: { scrollPosition: location.state && location.state.scrollPosition }
    };
  })();

  const dropdownMenu = (
    <DropdownMenu
      chat={chat}
      isOtherUserBlocked={isOtherUserBlocked}
      user={user}
      chatId={chatId}
      otherChatParticipantInfo={otherChatParticipantInfo}
    />
  )

  return (
    <Card className={styles.headerCard} bordered={false}>
      <div className={styles.backRow}>
        <Link to={backUrl} className={styles.backToMessagesLink}>
          <ChevronLeftIcon className={styles.backToMessagesChevron} />
          <span className={styles.backToMessages}>Natrag na poruke</span>
        </Link>
      </div>
      <div className={styles.userRow}>
        <div className={styles.userInfo} style={{ justifyContent: "space-between" }}>
          <div className={styles.userInfo}>
            <IndexAvatar
              url={otherChatParticipantInfo && otherChatParticipantInfo.avatar}
              size={60}
              className={styles.avatar}
            />
            <div className={styles.userDetails}>
              <Link
                to={`${PageRoute.user}/${encodeURIComponent(otherChatParticipantInfo && otherChatParticipantInfo.name)}`}
                className={styles.usernameLink}
              >
                <span className={styles.username}>{otherChatParticipantInfo && otherChatParticipantInfo.name}</span>
              </Link>
              <Link
                to={`${PageRoute.user}/${encodeURIComponent(otherChatParticipantInfo && otherChatParticipantInfo.name)}${PageRoute.userRatings}`}
                className={styles.ratingLink}
              >
                <RatingCounter user={otherChatParticipantInfo} />
              </Link>
            </div>
          </div>
          {isMobile && dropdownMenu}
        </div>
        <div className={styles.actions}>
          <RatingButton
            user={otherChatParticipantInfo}
            chatId={chatId}
            gaLabel="Ocijeni - iz poruke"
            className={styles.ratingButton}
          />
          {!isMobile && dropdownMenu}
        </div>
      </div>
    </Card>
  );
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/HeaderCard.tsx